import React, { useState } from "react";
import { Radio, Row, Col, Space, Input, Button, Card } from "antd";
import styled from "styled-components";
import { StyledParagraph, StyledTitle } from "../../components/CustomAntdComponents/Typography";
import { ReactComponent as CardIcon } from "../../assets/images/card.svg";
import { ReactComponent as PayIcon } from "../../assets/images/pay.svg";
import PhoneNumberInput from "../../components/PhoneNumberInput";
import { PRIMARY_COLOR, WHITE, GREY_1 } from "../../utils/colors";

type PaymentMethod = "card" | "mpesa";

type Props = {
  amount: number;
  currency: string;
  onPaymentSubmit: (method: PaymentMethod, data?: any) => void;
  loading?: boolean;
};

const B2CPayment: React.FC<Props> = ({ amount, currency, onPaymentSubmit, loading }) => {
  const [method, setMethod] = useState<PaymentMethod>("card");
  const [phone, setPhone] = useState("");

  const handleSubmit = () => {
    onPaymentSubmit(method, method === "mpesa" ? { phone } : {});
  };

  return (
    <PaymentWrapper>
      <StyledTitle level={4} style={{ marginBottom: 20 }}>
        Select Payment Method
      </StyledTitle>

      <Radio.Group
        onChange={(e) => setMethod(e.target.value)}
        value={method}
        style={{ width: "100%" }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <PaymentOptionCard $active={method === "card"}>
              <Radio value="card">
                <OptionContent>
                  <CardIcon width={24} height={24} />
                  <div>
                    <StyledParagraph strong>Card Payment</StyledParagraph>
                    <StyledParagraph size="small">Pay with Visa, Mastercard, or Verve</StyledParagraph>
                  </div>
                </OptionContent>
              </Radio>
            </PaymentOptionCard>
          </Col>
          <Col span={24}>
            <PaymentOptionCard $active={method === "mpesa"}>
              <Radio value="mpesa">
                <OptionContent>
                  <div className="mpesa-logo">M</div>
                  <div>
                    <StyledParagraph strong>Mpesa</StyledParagraph>
                    <StyledParagraph size="small">Pay with Mpesa STK Push</StyledParagraph>
                  </div>
                </OptionContent>
              </Radio>
            </PaymentOptionCard>
          </Col>
        </Row>
      </Radio.Group>

      {method === "mpesa" && (
        <MpesaInputWrapper>
          <StyledParagraph style={{ marginBottom: 8 }}>Enter Mpesa Phone Number</StyledParagraph>
          <PhoneNumberInput
            name="mpesaPhone"
            placeholder="07XX XXX XXX"
            onChange={(val) => setPhone(val)}
            value={phone}
          />
        </MpesaInputWrapper>
      )}

      <div style={{ marginTop: 30 }}>
        <Button
          type="primary"
          block
          size="large"
          onClick={handleSubmit}
          loading={loading}
          disabled={method === "mpesa" && !phone}
        >
          {method === "mpesa" ? "Pay with Mpesa" : "Pay Now"}
        </Button>
      </div>
    </PaymentWrapper>
  );
};

const PaymentWrapper = styled.div`
  padding: 20px;
  background: ${WHITE};
  border-radius: 8px;
`;

const PaymentOptionCard = styled.div<{ $active: boolean }>`
  border: 1px solid ${(props) => (props.$active ? PRIMARY_COLOR : GREY_1)};
  padding: 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${(props) => (props.$active ? `${PRIMARY_COLOR}05` : WHITE)};

  .ant-radio-wrapper {
    width: 100%;
    margin-right: 0;
  }
`;

const OptionContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: 8px;

  .mpesa-logo {
    width: 24px;
    height: 24px;
    background: #4caf50;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-weight: bold;
    font-size: 14px;
  }
`;

const MpesaInputWrapper = styled.div`
  margin-top: 20px;
  padding: 16px;
  background: #f9f9f9;
  border-radius: 8px;
`;

export default B2CPayment;
